// src/pages/PatientsOverview/components/PatientsList.js
import React, { useEffect } from "react";
import { Table, Button, Space, Modal, message } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPatientList,
  selectIsPatientModalOpen,
} from "../PatientsSelectors";
import { fetchPatientList, removePatient } from "../PatientsThunk";
import { openPatientModal } from "../PatientsSlice";
import PatientModal from "./PatientModal";
import dayjs from "dayjs";

const { confirm } = Modal;

const PatientsList = () => {
  const dispatch = useDispatch();
  const list = useSelector(selectPatientList);
  const isModalOpen = useSelector(selectIsPatientModalOpen);

  useEffect(() => {
    dispatch(fetchPatientList());
  }, [dispatch]);

  const handleEdit = (record) => {
    dispatch(openPatientModal(record));
  };

  const handleDelete = (record) => {
    confirm({
      title: "Are you sure delete this?",
      onOk: async () => {
        try {
          await dispatch(removePatient(record.patient_id)).unwrap();
          message.success("Patient deleted successfully");
          dispatch(fetchPatientList());
        } catch (err) {
          message.error(err?.message || "Delete failed");
        }
      },
    });
  };


  const columns = [
    {
      title: "No.",
      key: "index",
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "Name",
      dataIndex: "patient_name",
      key: "patient_name",
    },
    {
      title: "Insurance",
      dataIndex: "insurance_company",
      key: "insurance_company",
    },
    {
      title: "CoPay %",
      dataIndex: "co_pay_amount",
      key: "co_pay_amount",
    },
    {
      title: "Emirates Id",
      dataIndex: "emirates_id",
      key: "emirates_id",
    },
    {
      title: "Validity",
      dataIndex: "insurance_validity",
      key: "insurance_validity",
      render: (v) => (v ? dayjs(v).format("YYYY-MMM-DD") : "-"),
    },
    {
      title: "Phone",
      dataIndex: "phone_no",
      key: "phone_no",
      render: (val, rec) =>
        rec.country_code ? `+${rec.country_code} ${val}` : val,
    },
    {
      title: "Total",
      dataIndex: "total_patient_sales",
      key: "total_patient_sales",
      render: v => Number(v).toFixed(2)
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>       
          </Button>
          <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record)}>
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 16,
        }}
      >
        <Button
          type="primary"
          onClick={() => dispatch(openPatientModal(null))}
          data-testid="new-patient"
        >
          + New Patient
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={list}
        rowKey={(r) => r.patient_id || Math.random()}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />
      {isModalOpen && <PatientModal />}
    </div>
  );
};

export default PatientsList;
